/**
 * A base config containing properties for charts
 */
var ChartConfigBase = /** @class */ (function () {
    function ChartConfigBase() {
    }
    return ChartConfigBase;
}());
export { ChartConfigBase };
//# sourceMappingURL=chart-config-base.js.map